import { useMemo } from 'react';

export default function useMemoObject<T extends object>(obj: T): T {
  return useMemo(() => obj, [obj, ...Object.values(obj)]); // eslint-disable-line react-hooks/exhaustive-deps
}
